// extracted by mini-css-extract-plugin
export default {"highlight":"highlight_highlight__GMzHG","highlightItem":"highlight_highlightItem__Oxt62"};